module.exports = __webpack_public_path__ + "img/d4.1b9a8cfb.jpg";